function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x34_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838384"
    },
    d: "M468.125,128.73C304.284,99.474,234.069,0,234.069,0S163.848,99.474,0.013,128.73 c0,64.367-5.858,277.944,234.057,383.27C473.977,406.675,468.125,193.098,468.125,128.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F2F1"
    },
    d: "M234.069,466.88C63.977,384.073,43.61,240.378,41.256,161.786 c95.349-23.792,158.067-69.25,192.814-101.558c34.746,32.308,97.458,77.766,192.807,101.558 C424.528,240.378,404.155,384.073,234.069,466.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C57B"
    },
    d: "M410.284,169.867c-1.813,70.95-19.134,203.716-176.214,279.583 c-29.05-14.015-53.306-29.989-73.583-47.191c-27.411-23.173-47.513-48.568-62.293-74.285 c-33.346-58.164-39.32-118.025-40.346-158.106c88.156-21.531,145.384-63.78,176.221-92.92 c15.328,14.483,37.185,32.21,66.118,49.035c26.16,15.183,58.132,29.637,96.284,40.256 C400.981,167.525,405.6,168.725,410.284,169.867z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727171"
    },
    d: "M234.069,76.947c-30.837,29.14-88.066,71.389-176.221,92.92 c0.613,23.74,3.006,54.442,11.742,87.595h164.48V76.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.26,
      fill: "#F4E228"
    },
    d: "M396.472,166.238c-38.153-10.618-70.124-25.073-96.284-40.256 c-28.934-16.825-50.79-34.552-66.118-49.035v180.515h164.505c8.748-33.153,11.103-63.841,11.709-87.595 C405.6,168.725,400.981,167.525,396.472,166.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.26,
      fill: "#F4E228"
    },
    d: "M69.589,257.462c6.012,22.824,15.012,46.8,28.604,70.512 c14.78,25.718,34.882,51.113,62.293,74.285c20.277,17.202,44.533,33.176,73.583,47.191V257.462H69.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#727171"
    },
    d: "M234.069,449.449c104.49-50.468,147.133-126.108,164.505-191.988H234.069V449.449z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.08,
      fill: "#231815"
    },
    d: "M234.069,0c0,0,70.215,99.474,234.056,128.73c0,64.367,5.851,277.944-234.056,383.27V0 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecurity);
export default __webpack_public_path__ + "static/media/Ic_security.b304948c97c23609e717eca277c54332.svg";
export { ForwardRef as ReactComponent };